"use client";
import { Box, Image, Text, Link } from "@chakra-ui/react"
import React, { useRef, useEffect, useState } from "react"
import { handleKarmaNavigation, modifyDatoImgUrlToStatic } from "./utils";


let svgIcons = {
    'video': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 4.74976H15.25V19.2498H2.75V4.74976Z" stroke="#B7870C" stroke-width="1.5" />
        <path d="M15.25 9.99976L21.25 6.99976V16.9998L15.25 13.9998V9.99976Z" stroke="#B7870C" stroke-width="1.5" />
    </svg>,
    'poem': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 3.75V3H2V3.75H2.75ZM16.25 3.75H17V3H16.25V3.75ZM21.25 12H22V11.25H21.25V12ZM6.75 15H6V16.5H6.75V15ZM12.25 16.5H13V15H12.25V16.5ZM6.75 7.75V7H6V7.75H6.75ZM12.25 7.75H13V7H12.25V7.75ZM12.25 12.25V13H13V12.25H12.25ZM6.75 12.25H6V13H6.75V12.25ZM2.75 3.75V4.5H16.25V3.75V3H2.75V3.75ZM21.25 17.75H22V12H21.25H20.5V17.75H21.25ZM16.25 3.75H15.5V12H16.25H17V3.75H16.25ZM16.25 12H15.5V17.75H16.25H17V12H16.25ZM21.25 12V11.25H16.25V12V12.75H21.25V12ZM2.75 3.75H2V17.75H2.75H3.5V3.75H2.75ZM5.25 20.25V21H18.5V20.25V19.5H5.25V20.25ZM2.75 17.75H2C2 19.5449 3.45507 21 5.25 21V20.25V19.5C4.2835 19.5 3.5 18.7165 3.5 17.75H2.75ZM18.75 20.25V21C20.5449 21 22 19.5449 22 17.75H21.25H20.5C20.5 18.7165 19.7165 19.5 18.75 19.5V20.25ZM18.75 20.25V19.5C17.7835 19.5 17 18.7165 17 17.75H16.25H15.5C15.5 19.5449 16.9551 21 18.75 21V20.25ZM6.75 15.75V16.5H12.25V15.75V15H6.75V15.75ZM6.75 7.75V8.5H12.25V7.75V7H6.75V7.75ZM12.25 7.75H11.5V12.25H12.25H13V7.75H12.25ZM12.25 12.25V11.5H6.75V12.25V13H12.25V12.25ZM6.75 12.25H7.5V7.75H6.75H6V12.25H6.75Z" fill="#B7870C" />
    </svg>,
    'text': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 3.75V3H2V3.75H2.75ZM16.25 3.75H17V3H16.25V3.75ZM21.25 12H22V11.25H21.25V12ZM6.75 15H6V16.5H6.75V15ZM12.25 16.5H13V15H12.25V16.5ZM6.75 7.75V7H6V7.75H6.75ZM12.25 7.75H13V7H12.25V7.75ZM12.25 12.25V13H13V12.25H12.25ZM6.75 12.25H6V13H6.75V12.25ZM2.75 3.75V4.5H16.25V3.75V3H2.75V3.75ZM21.25 17.75H22V12H21.25H20.5V17.75H21.25ZM16.25 3.75H15.5V12H16.25H17V3.75H16.25ZM16.25 12H15.5V17.75H16.25H17V12H16.25ZM21.25 12V11.25H16.25V12V12.75H21.25V12ZM2.75 3.75H2V17.75H2.75H3.5V3.75H2.75ZM5.25 20.25V21H18.5V20.25V19.5H5.25V20.25ZM2.75 17.75H2C2 19.5449 3.45507 21 5.25 21V20.25V19.5C4.2835 19.5 3.5 18.7165 3.5 17.75H2.75ZM18.75 20.25V21C20.5449 21 22 19.5449 22 17.75H21.25H20.5C20.5 18.7165 19.7165 19.5 18.75 19.5V20.25ZM18.75 20.25V19.5C17.7835 19.5 17 18.7165 17 17.75H16.25H15.5C15.5 19.5449 16.9551 21 18.75 21V20.25ZM6.75 15.75V16.5H12.25V15.75V15H6.75V15.75ZM6.75 7.75V8.5H12.25V7.75V7H6.75V7.75ZM12.25 7.75H11.5V12.25H12.25H13V7.75H12.25ZM12.25 12.25V11.5H6.75V12.25V13H12.25V12.25ZM6.75 12.25H7.5V7.75H6.75H6V12.25H6.75Z" fill="#B7870C" />
    </svg>,
    'audio': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0009 19C15.0764 19 17.7195 17.1489 18.8769 14.5M12.0009 19C8.92546 19 6.28233 17.1489 5.125 14.5M12.0009 19V21.25M12.0009 15.75C9.65372 15.75 7.75093 13.8472 7.75093 11.5V7C7.75093 4.65279 9.65372 2.75 12.0009 2.75C14.3481 2.75 16.2509 4.65279 16.2509 7V11.5C16.2509 13.8472 14.3481 15.75 12.0009 15.75Z" stroke="#B7870C" stroke-width="1.5" stroke-linecap="square" />
    </svg>
}

let AllBlogsList = ({ sectionContent }) => {
    const [lineClamps, setLineClamps] = useState({});
    const containerRef = useRef(null);

    const calculateAvailableLines = (titleElement, containerHeight = 244) => {
        if (!titleElement) return 3; // fallback
        
        const titleHeight = titleElement.offsetHeight;
        const padding = 95; // 20px top + 20px bottom + 20px icon space
        const availableHeight = containerHeight - titleHeight - padding;
        const lineHeight = 21; // summary line height
        const maxLines = Math.floor(availableHeight / lineHeight);
        
        return Math.max(1, maxLines); // minimum 1 line
    };

    useEffect(() => {
        if (containerRef.current && sectionContent?._allReferencingKarmaMicrositeBlogs) {
            const containers = containerRef.current.querySelectorAll('.blog-container');
            const newLineClamps = {};
            
            containers.forEach((container, index) => {
                const titleEl = container.querySelector('.blog-title');
                const lineClamp = calculateAvailableLines(titleEl);
                newLineClamps[index] = lineClamp;
            });
            
            setLineClamps(newLineClamps);
        }
    }, [sectionContent]);

    return (<Box py={{ base: '70px', md: '100px' }} display={'flex'} justifyContent={'center'} bgColor={'#fff'}>

        <Box ref={containerRef} width={{ base: 'auto', md: '682px', 'lg': '1017px' }} display={'flex'} flexDir={{ base: 'column', md: 'row' }} flexWrap={'wrap'} gap={'30px'}>
            {sectionContent?._allReferencingKarmaMicrositeBlogs?.map((item, j) => {
                return <Link
                    textDecoration={'none'}
                    href={handleKarmaNavigation(`${`/articles/${item?.urlAlias}`}`)}
                    width={'319px'} 
                    _hover={{
                        textDecor: 'none'
                    }}
                >
                    <Box>
                    <Image width={'100%'} height={'180px'}
                        src={modifyDatoImgUrlToStatic(item?.heroImage?.url)}
                    />
                    <Box className="blog-container" padding={'20px'} pt={'15px'} height={'244px'} border={'1px solid #B7870C'} display={'flex'} flexDirection={'column'} >
                        {svgIcons[item?.articleType]}
                        <Text
                            className="blog-title"
                            my={'10px'} fontWeight={500} color={"#000000"} fontFamily={'var(--AustinMedium)'} fontSize={{ base: '26px' }} lineHeight={{ base: '24px' }}>{item?.title}</Text>
                        <Box flex={1} minHeight={0} overflow={'hidden'}>
                            <Text 
                                fontWeight={400} color={"#000000"} fontFamily={'var(--FedraSansStd-book)'} fontSize={{ base: '14px' }} lineHeight={{ base: '21px' }} 
                                style={{ 
                                    display: '-webkit-box', 
                                    WebkitLineClamp: lineClamps[j] || 3, 
                                    WebkitBoxOrient: 'vertical', 
                                    overflow: 'hidden', 
                                    textOverflow: 'ellipsis' 
                                }}
                            >
                                {item?.summary}
                            </Text>
                        </Box>
                    </Box>
                    </Box>
                </Link>
            })}

        </Box>
    </Box>)
}

export default AllBlogsList;